var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFnf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 28,
    viewBox: "0 0 57 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2550",
    "data-name": "\\uC0AC\\uAC01\\uD615 2550",
    width: 57,
    height: 28,
    transform: "translate(-12395 2367)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2549",
    "data-name": "\\uC0AC\\uAC01\\uD615 2549",
    width: 56.333,
    height: 26,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_8",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 8",
    transform: "translate(12395 -2367)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4106",
    "data-name": "\\uADF8\\uB8F9 4106",
    transform: "translate(-12395 2368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4105",
    "data-name": "\\uADF8\\uB8F9 4105",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2975",
    "data-name": "\\uD328\\uC2A4 2975",
    d: "M134.207,24.426l-5.936-5.889a27.9,27.9,0,0,0,1.28-3.415h3.607a.153.153,0,0,0,.152-.153V11.838a.153.153,0,0,0-.152-.152h-6.117a.153.153,0,0,0-.148.115,33.419,33.419,0,0,1-1.246,4.134l-4.086-4.053a11.636,11.636,0,0,0,2.518-1.93A5.978,5.978,0,0,0,122.442.8a6.092,6.092,0,0,0-7.3.961l-.045.044a6.031,6.031,0,0,0-1.643,2.968A6.123,6.123,0,0,0,114.743,9.9c.415.479.822.888,1.251,1.3a21.883,21.883,0,0,0-2.17,1.535A7.487,7.487,0,0,0,118.6,26a9.586,9.586,0,0,0,7.907-4.379l2.916,2.893a.489.489,0,0,0,.346.142h4.346a.135.135,0,0,0,.095-.23M122.049,5.52a2.727,2.727,0,0,1-.581,2.2,8.495,8.495,0,0,1-2.092,1.442l-.351.2c-.914-.88-1.569-1.6-1.575-1.606a2.7,2.7,0,0,1-.581-2.2,2.713,2.713,0,0,1,1.607-1.923,2.514,2.514,0,0,1,2.258.143,2.655,2.655,0,0,1,1.316,1.743M118.6,22.564A4.084,4.084,0,0,1,115.41,21.1a4.131,4.131,0,0,1,.644-5.76,15.2,15.2,0,0,1,2.467-1.642l5.5,5.457c-1.487,2.25-3.318,3.405-5.425,3.405",
    transform: "translate(-95.231 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2976",
    "data-name": "\\uD328\\uC2A4 2976",
    d: "M14.435,4.47H.108A.108.108,0,0,0,0,4.577v23.8a.108.108,0,0,0,.108.107H3.327a.107.107,0,0,0,.107-.107v-9.43h9.557a.107.107,0,0,0,.107-.107V15.626h0a.107.107,0,0,0-.107-.108H3.434V7.9h11a.107.107,0,0,0,.107-.107V4.577a.107.107,0,0,0-.107-.107",
    transform: "translate(0 -3.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2977",
    "data-name": "\\uD328\\uC2A4 2977",
    d: "M307.269,4.47H292.942a.108.108,0,0,0-.108.107v23.8a.108.108,0,0,0,.108.107h3.219a.107.107,0,0,0,.107-.107v-9.43h9.557a.107.107,0,0,0,.107-.107V15.626h0a.107.107,0,0,0-.107-.108h-9.557V7.9h11a.107.107,0,0,0,.107-.107V4.577a.107.107,0,0,0-.107-.107",
    transform: "translate(-251.043 -3.832)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFnf);
export default __webpack_public_path__ + "static/media/logoFnf.a849dc6667a7462010f9f353fee6e355.svg";
export { ForwardRef as ReactComponent };